// Renderiza um ícone lucide a partir de um NOME (string) — para mapas de dados
// dinâmicos (ex.: getTypeMeta().icon), onde o ícone vem de config/serviço.
import {
  MessageCircle, Phone, Mail, Repeat, Handshake, Shuffle, X, Check, CircleX,
  StickyNote, Calendar, Sparkles, Circle, Building2, Wrench, RefreshCw, Trophy,
  Briefcase, DollarSign, Landmark, Target, ClipboardList, Link2, Camera, Inbox,
  LogOut, Trash2, Lock, MapPin, User, Zap, AlertTriangle, Pencil, RotateCcw,
  type LucideProps, type LucideIcon,
} from 'lucide-react';

const ICONS: Record<string, LucideIcon> = {
  'message-circle': MessageCircle,
  phone: Phone,
  mail: Mail,
  repeat: Repeat,
  handshake: Handshake,
  shuffle: Shuffle,
  x: X,
  check: Check,
  'circle-x': CircleX,
  note: StickyNote,
  calendar: Calendar,
  sparkles: Sparkles,
  dot: Circle,
  building: Building2,
  wrench: Wrench,
  refresh: RefreshCw,
  trophy: Trophy,
  briefcase: Briefcase,
  dollar: DollarSign,
  landmark: Landmark,
  target: Target,
  clipboard: ClipboardList,
  link: Link2,
  camera: Camera,
  inbox: Inbox,
  logout: LogOut,
  trash: Trash2,
  lock: Lock,
  'map-pin': MapPin,
  user: User,
  zap: Zap,
  alert: AlertTriangle,
  pencil: Pencil,
  rotate: RotateCcw,
};

interface DynIconProps extends Omit<LucideProps, 'name'> {
  name: string | null | undefined;
}

export function DynIcon({ name, ...props }: DynIconProps) {
  const Icon = (name && ICONS[name]) || Circle;
  return <Icon {...props} />;
}

export default DynIcon;
